export const GET_GROUP_OVERVIEW = 'GET_GROUP_OVERVIEW';
export const GET_GROUP_OVERVIEW_SUCCESS = 'GET_GROUP_OVERVIEW_SUCCESS';
export const RESET_GROUP_OVERVIEW = 'RESET_GROUP_OVERVIEW';

export const CLICK_CREATE_CONTENT_BUTTON = 'CLICK_CREATE_CONTENT_BUTTON';
export const VIEW_HELP_CENTER_ARTICLE = 'VIEW_HELP_CENTER_ARTICLE';
